const routes = {
  landing: '/landing',
  projectDetail: '/projects/:slug',
  pet: '/pet/policy',
  petPolicy: '/pet-circle/policy',
  root: '/',
  sticky: '/labs/sticky',
}

export default routes
